import React from 'react'

const InfoWarningIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="28" fill="#DBDEF1" />

      <rect x="16" y="16" width="24" height="24" fill="#D9D9D9" />
      <path
        d="M28 29C28.2833 29 28.521 28.904 28.713 28.712C28.9043 28.5207 29 28.2833 29 28V23.975C29 23.6917 28.9043 23.4583 28.713 23.275C28.521 23.0917 28.2833 23 28 23C27.7167 23 27.4793 23.0957 27.288 23.287C27.096 23.479 27 23.7167 27 24V28.025C27 28.3083 27.096 28.5417 27.288 28.725C27.4793 28.9083 27.7167 29 28 29ZM28 33C28.2833 33 28.521 32.904 28.713 32.712C28.9043 32.5207 29 32.2833 29 32C29 31.7167 28.9043 31.479 28.713 31.287C28.521 31.0957 28.2833 31 28 31C27.7167 31 27.4793 31.0957 27.288 31.287C27.096 31.479 27 31.7167 27 32C27 32.2833 27.096 32.5207 27.288 32.712C27.4793 32.904 27.7167 33 28 33ZM28 38C26.6167 38 25.3167 37.7373 24.1 37.212C22.8833 36.6873 21.825 35.975 20.925 35.075C20.025 34.175 19.3127 33.1167 18.788 31.9C18.2627 30.6833 18 29.3833 18 28C18 26.6167 18.2627 25.3167 18.788 24.1C19.3127 22.8833 20.025 21.825 20.925 20.925C21.825 20.025 22.8833 19.3123 24.1 18.787C25.3167 18.2623 26.6167 18 28 18C29.3833 18 30.6833 18.2623 31.9 18.787C33.1167 19.3123 34.175 20.025 35.075 20.925C35.975 21.825 36.6873 22.8833 37.212 24.1C37.7373 25.3167 38 26.6167 38 28C38 29.3833 37.7373 30.6833 37.212 31.9C36.6873 33.1167 35.975 34.175 35.075 35.075C34.175 35.975 33.1167 36.6873 31.9 37.212C30.6833 37.7373 29.3833 38 28 38Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default InfoWarningIcon
